import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "../lib/api";
import { useAuth } from "./AuthContext";

const ModeContext = createContext(null);

export function ModeProvider({ children }) {
  const { user } = useAuth();
  const [account, setAccount] = useState(null);
  const [mode, setModeState] = useState("demo");

  const refreshAccount = useCallback(async () => {
    try {
      const { data } = await api.get("/account");
      setAccount(data);
      setModeState(data.active_mode || "demo");
    } catch {
      /* not logged in */
    }
  }, []);

  useEffect(() => {
    if (user && typeof user === "object") refreshAccount();
  }, [user, refreshAccount]);

  const setMode = async (newMode) => {
    setModeState(newMode);
    try {
      await api.post("/account/mode", { mode: newMode });
      await refreshAccount();
    } catch {
      /* noop */
    }
  };

  const balance =
    account && (mode === "demo" ? account.demo_wallet?.balance : account.live_wallet?.balance);

  return (
    <ModeContext.Provider value={{ mode, setMode, account, refreshAccount, balance: balance ?? 0 }}>
      {children}
    </ModeContext.Provider>
  );
}

export const useMode = () => useContext(ModeContext);
